/* Cocomelot sticky purchase bar — revision 2026-08-03.2 */
(() => {
  const stickyBar = document.querySelector('[data-cc-sticky-atc]');
  if (!stickyBar) return;

  const sectionId = stickyBar.dataset.section;
  const stickyButton = stickyBar.querySelector('[data-cc-sticky-button]');
  const stickyPrice = stickyBar.querySelector('[data-cc-sticky-price]');
  let submitButton;
  let observer;
  let mutationObserver;
  let visibilityFrame;

  const getSubmitButton = () => document.querySelector(`#ProductSubmitButton-${CSS.escape(sectionId)}`);

  const getPriceText = () => {
    const productInfo = document.querySelector(`product-info[data-section="${CSS.escape(sectionId)}"]`);
    const price =
      productInfo?.querySelector('.price__sale .price-item--sale') ||
      productInfo?.querySelector('.price__regular .price-item--regular') ||
      productInfo?.querySelector('.price-item--regular');
    return price?.textContent.trim();
  };

  const setVisibility = (visible) => {
    stickyBar.classList.toggle('is-visible', visible);
    stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    if (visible) {
      stickyBar.removeAttribute('inert');
    } else {
      stickyBar.setAttribute('inert', '');
    }
    document.body.classList.toggle('cc-sticky-atc-visible', visible);
  };

  const updateVisibility = () => {
    visibilityFrame = null;
    submitButton = getSubmitButton();
    if (!submitButton) {
      setVisibility(false);
      return;
    }

    const submitRect = submitButton.getBoundingClientRect();
    setVisibility(window.scrollY > 0 && submitRect.bottom < 0);
  };

  const requestVisibilityUpdate = () => {
    if (visibilityFrame) return;
    visibilityFrame = window.requestAnimationFrame(updateVisibility);
  };

  const syncButton = () => {
    submitButton = getSubmitButton();
    if (!submitButton) {
      stickyButton.disabled = true;
      stickyButton.textContent = 'Niet beschikbaar';
      return;
    }

    const originalLabel = submitButton.querySelector('span')?.textContent.trim();
    stickyButton.disabled = submitButton.disabled;
    stickyButton.textContent = originalLabel || (submitButton.disabled ? 'Niet beschikbaar' : 'In winkelwagen');

    const currentPrice = getPriceText();
    if (currentPrice && stickyPrice) stickyPrice.textContent = currentPrice;
  };

  const observeSubmitButton = () => {
    observer?.disconnect();
    mutationObserver?.disconnect();
    submitButton = getSubmitButton();
    if (!submitButton) return;

    observer = new IntersectionObserver(
      ([entry]) => {
        const hasPassedButton = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        setVisibility(hasPassedButton);
      },
      { threshold: 0.01 }
    );
    observer.observe(submitButton);

    mutationObserver = new MutationObserver(syncButton);
    mutationObserver.observe(submitButton, {
      attributes: true,
      childList: true,
      subtree: true,
    });
    requestVisibilityUpdate();
  };

  stickyButton.addEventListener('click', () => {
    syncButton();
    if (submitButton && !submitButton.disabled) submitButton.click();
  });

  const variantEventName = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS.variantChange : null;
  if (typeof subscribe === 'function' && variantEventName) {
    subscribe(variantEventName, (event) => {
      if (event?.data?.sectionId !== sectionId) return;
      window.requestAnimationFrame(() => {
        syncButton();
        observeSubmitButton();
      });
    });
  }

  syncButton();
  observeSubmitButton();
  window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
  window.addEventListener('resize', requestVisibilityUpdate, { passive: true });

  window.addEventListener(
    'pagehide',
    () => {
      observer?.disconnect();
      mutationObserver?.disconnect();
      if (visibilityFrame) window.cancelAnimationFrame(visibilityFrame);
      window.removeEventListener('scroll', requestVisibilityUpdate);
      window.removeEventListener('resize', requestVisibilityUpdate);
      setVisibility(false);
    },
    { once: true }
  );
})();
